import type { IconAliases } from './icons';

const aliases: IconAliases = {
  itemAdd: 'mdi-plus',
  itemMoveUp: 'mdi-arrow-up',
  itemMoveDown: 'mdi-arrow-down',
  itemDelete: 'mdi-delete',
  calendarClock: 'mdi-calendar-clock',
  clock: 'mdi-clock-outline',
  passwordHide: 'mdi-eye-off',
  passwordShow: 'mdi-eye',
  validationError: 'mdi-alert-circle-outline',
};

export { aliases };
